import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose, Transform } from 'class-transformer';
import { Types } from 'mongoose';

export abstract class BaseOutputModel {
  @ApiProperty({ name: 'id', type: String, format: 'bson' })
  @Expose({ name: 'id' })
  @Transform(({ obj }) => obj._id.toString())
  public readonly _id!: Types.ObjectId;

  @ApiProperty()
  public readonly created_at!: Date;

  @ApiPropertyOptional({ type: String, format: 'bson' })
  @Transform(({ obj }) => obj.created_by?.toString())
  public readonly created_by?: Types.ObjectId;

  @Exclude()
  public readonly deleted!: boolean;

  @ApiProperty()
  public readonly updated_at!: Date;

  @ApiPropertyOptional({ type: String, format: 'bson' })
  @Transform(({ obj }) => obj.updated_by?.toString())
  public readonly updated_by?: Types.ObjectId;

  constructor(object: object | null) {
    Object.assign(this, object);
  }
}
